import "./App.css";
import WeatherReport from "./components/WeatherReport";

function App() {
  return (
    <div className="app-shell">
      <main className="app-layout">
        <WeatherReport />
      </main>
    </div>
  );
}

export default App;
